export const setUser = (token, profileId) => {
  sessionStorage.setItem("token", JSON.stringify(token));
  sessionStorage.setItem("profileId", JSON.stringify(profileId));
};
export const getUser = () =>
  sessionStorage.getItem("token")
    ? JSON.parse(sessionStorage.getItem("token"))
    : "";

export const getToken = () => {
  return sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
    ? JSON.parse(sessionStorage.getItem("token")).token
    : "";
};

export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("profileId");
};

//REACT_APP_DISTRIBUTOR
const distList = process.env.REACT_APP_DISTRIBUTOR;

var distributerList = JSON.parse(distList);
console.log("distributerList", distributerList);
export const isUserAdmin = (loggedRetailerId) => {
  const filterRetailerAndRole = distributerList.filter(
    (val) => val.id == loggedRetailerId
  );
  console.log("filterRetailer", filterRetailerAndRole);
  if (filterRetailerAndRole.length > 0) {
    return true;
  } else {
    return false;
  }
};
export const isSuperAdmin = (loggedRetailerId) => {
  const isSuperAdminUser = process.env.REACT_APP_SUPER_ADMIN;
  const filterRetailerAndRole = distributerList.filter(
    (val) => val.id == loggedRetailerId
  );
  if (
    filterRetailerAndRole.length > 0 &&
    filterRetailerAndRole[0].role == isSuperAdminUser
  ) {
    return true;
  } else {
    return false;
  }
};

const checkcommercialName = (value) => {
  return /^[a-zA-Z0-9 ]{5,50}$/.test(value);
};

export const validCommercialName = new RegExp("^[a-zA-Z0-9 ]{5,50}$");

const checkName = (value) => {
  return /^[A-Za-z.\s_-]+$/.test(value);
};
const checkMobileNumber = (value) => {
  return /^[0-9]{10}$/.test(value);
};
const checkAccountNumber = (value) => {
  return /^[0-9]$/.test(value);
};
const checkEmailId = (value) => {
  return /^\S+@\S+\.\S+$/.test(value);
};
const checkAddress = (value) => {
  return /[^a-zA-Z0-9\,\-\/ ]/.test(value);
};
const checkPassword = (value) => {
  return /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$/.test(value);
};
//
const checkDob = (value) => {
  return /^(\d{1,2})-(\d{1,2})-(\d{4})$/.test(value);
};
const checkAlphanumeric = (value) => {
  return /^[a-z0-9]+$/.test(value);
};
const checkValidateWeight = (value) => {
  return /^[1-9][0-9]*$/.test(value);
};
//^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$
const checkURL = (value) => {
  var httpRegex =
    /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
  return httpRegex.test(value);
};
const allnumeric = (inputtxt) => {
  var numbers = /^[0-9]+$/;
  if (inputtxt.match(numbers)) {
    // alert('Your Registration number has accepted....');
    // document.form1.text1.focus();
    return true;
  } else {
    // alert('Please input numeric characters only');
    // document.form1.text1.focus();
    return false;
  }
};
const stylesofStype = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "none",
    borderColor: "none",
    border: "none",
    padding: "0px",
    borderRadius: "0px",
    minHeight: "16px",
    boxShadow: "none",
    fontSize: "16px",
    // border: state.isFocused && "none"
  }),
  valueContainer: (styles) => ({
    ...styles,
    backgroundColor: "none",
    border: "none",
    padding: "0px",
    borderRadius: "0px",
  }),
  multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
  //IndicatorsContainer
  input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
  //singleValue
  singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
};
const stylesofStypeNew = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "none",
    borderColor: "red",
    border: "0px",
    padding: "0px",
    borderRadius: "0px",
    minHeight: "10px",
    boxShadow: "none",
    fontSize: "16px",
    // border: state.isFocused && "none"
  }),
  valueContainer: (styles) => ({
    ...styles,
    backgroundColor: "none",
    border: "none",
    padding: "0px 12px",
    borderRadius: "0px",
  }),
  multiValue: (styles) => ({ ...styles, lineHeight: "16px" }),
  IndicatorsContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
  }),
  indicatorContainer: (styles) => ({
    ...styles,
    padding: "0px",
    margin: "0px",
  }),
  input: (styles) => ({ ...styles, padding: "0px", margin: "0px" }),
  //singleValue
  singleValue: (styles) => ({ ...styles, fontSize: "14px" }),
};
//`/api/v1/proxy/mobile/order/history/mis`
var paymentStatus = [
  { id: "SUCCESS", count: 0, total: 0 },
  { id: "FAILED", count: 0, total: 0 },
  { id: "PENDING", count: 0, total: 0 },
  { id: "OTHER", count: 0, total: 0 },
];
const fetchStatus = async (
  pageindex,
  id,
  isAdmin,
  selectedId,
  setDataLoading,
  setsearch,
  axiosInstance,
  url,
  requesterId,
  uuid,
  formDate,
  currentDate,
  nextDate,
  toDate,
  finalSelectedStatus,
  setTransactionStatuswithAmount,
  setIsDataLoaded,
  toast,
  e,
  finalSelectedtxnCat
) => {
  //console.log('finalSelectedtxnCat', finalSelectedtxnCat)
  setDataLoading(true);
  setsearch("");
  const reqPayload = {
    header: {
      "client-id": id, // client id will admin id
      role: "ROLE_RETAILER_FINXPAY",
      msgType: "ORDER_HISTORY",
      channel: "ADMIN",
      requesterId: requesterId,
      requestId: uuid(),
      time: new Date(),
    },
    device: null,
    agentId: isAdmin ? selectedId : id,
    pageNo: pageindex,
    startDate: formDate == "" ? currentDate : formDate,
    endDate: toDate == "" ? nextDate : toDate,
    status:
      finalSelectedStatus !== undefined && finalSelectedStatus.length !== 0
        ? finalSelectedStatus
        : null,
  };
  if (finalSelectedtxnCat !== undefined && finalSelectedtxnCat?.length !== 0) {
    reqPayload.txnCategory = finalSelectedtxnCat;
  } else if (
    finalSelectedtxnCat !== undefined &&
    finalSelectedtxnCat?.length == 0
  ) {
    reqPayload.txnCategory = null;
  }
  const response = await axiosInstance
    .post(url, reqPayload, {
      headers: {
        Authorization: `Bearer ${e}`,
        "client-id": id,
        role: "ROLE_RETAILER_FINXPAY",
      },
    })
    .then((res) => {
      let result2 = res?.data?.data || [];
      var result1 = [...paymentStatus];
      let finalResult = [...result1, ...result2];
      const arrayUniqueByKey = [
        ...finalResult
          .reduce(
            (r, o) =>
              !r.has(o.id) ||
              r.get(o.id).count < o.count ||
              r.get(o.id).total < o.total
                ? r.set(o.id, o)
                : r,
            new Map()
          )
          .values(),
      ];
      const addFilnalTotalSatus = arrayUniqueByKey.map((val, ins, self) => {
        if (val.id == "SUCCESS" || val.id == "FAILED" || val.id == "PENDING") {
          return val;
        } else {
          const currentObj = self[3];
          currentObj.count = currentObj.count + val.count;
          currentObj.total = currentObj.total + val.total;
          return currentObj;
        }
      });
      const unique = [...new Set(addFilnalTotalSatus)];
      //   console.log('unique', unique)
      setTransactionStatuswithAmount(unique);
    })
    .catch((err) => {
      //console.log(err);
      setDataLoading(false);
      setIsDataLoaded(false);
      toast.error("Something went wrong");
    });

  if (response) {
    const result = response.data.orders;

    if (result) {
    }

    return response.data;
  }
  return false;
};
const requestLoading = () => (
  <div class="overlay">
    <div class="overlay__inner">
      <div class="overlay__content">
        <span class="spinner"></span>
      </div>
    </div>
  </div>
);
async function copyTextToClipboard(text, toast) {
  try {
    const trimmedText = text.trim(); // Remove leading & trailing spaces
    await navigator.clipboard.writeText(trimmedText);
    toast.success("Text copied to clipboard.", { autoClose: 100 });
  } catch (err) {
    console.error("Unable to copy text to clipboard:", err);
    toast.error("Failed to copy text to clipboard.");
  }
}

function darkenColor(hex, amount = 20) {
  let color = hex.replace("#", "");

  // If color is shorthand (e.g., #fff), expand it to full form (e.g., #ffffff)
  if (color.length === 3) {
    color = color
      .split("")
      .map((char) => char + char)
      .join("");
  }

  const num = parseInt(color, 16);

  let r = (num >> 16) - amount;
  let g = ((num >> 8) & 0x00ff) - amount;
  let b = (num & 0x0000ff) - amount;

  // Clamp values between 0 and 255
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));

  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}
const nopagepermission = "no page permission";
const primaryColor = "";
export const utrLeng = (utr) => {
  const values = utr !== undefined && utr !== null ? utr : "";
  return values;
};
export {
  checkcommercialName,
  checkName,
  checkMobileNumber,
  checkEmailId,
  checkAddress,
  checkAccountNumber,
  checkPassword,
  checkDob,
  checkAlphanumeric,
  allnumeric,
  checkValidateWeight,
  checkURL,
  stylesofStype,
  stylesofStypeNew,
  fetchStatus,
  paymentStatus,
  requestLoading,
  copyTextToClipboard,
  darkenColor,
  nopagepermission,
  primaryColor,
};
